import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';

export const LowInventoryLeadFormAsync = lazyLoad({
  loader: () => import(/* webpackChunkName: "low-inventory-lead-form" */ './low-inventory-lead-form'),
  componentName: 'LowInventoryLeadForm',
});
